import script from "./m-notification.vue?vue&type=script&setup=true&lang=js"
export * from "./m-notification.vue?vue&type=script&setup=true&lang=js"

import "./m-notification.vue?vue&type=style&index=0&id=f2ca9b52&lang=scss"

const __exports__ = script;

export default __exports__